export default __webpack_public_path__ + "static/media/comm 3.7cfbaec9.jpg";